import { CheckinCommonModel } from '../../interface/checkin-common';

/**
 * CheckinCommon store state
 */
export interface CheckinCommonState extends CheckinCommonModel {}

/**
 * Name of the CheckinCommon Store
 */
export const CHECKIN_COMMON_STORE_NAME = 'checkinCommon';

/**
 * CheckinCommon Store Interface
 */
export interface CheckinCommonStore {
  /** CheckinCommon state */
  [CHECKIN_COMMON_STORE_NAME]: CheckinCommonState;
}
